export const ResponsiveMetric = {
  EXTRA_SMALL_MAX: 800,
  SMALL_MIN: 801,
  SMALL_MAX: 1279,
  MEDIUM_MIN: 1280,
  MEDIUM_MAX: 1919,
  LARGE_MIN: 1920,
} as const;

export const MatchMedia = {
  EXTRA_SMALL: `screen and (max-width: ${ResponsiveMetric.EXTRA_SMALL_MAX}px)`, // ~800px

  SMALL: `screen and (min-width: ${ResponsiveMetric.SMALL_MIN}px) and (max-width: ${ResponsiveMetric.SMALL_MAX}px)`, // 801px ~ 1279px
  TIL_SMALL: `screen and (max-width: ${ResponsiveMetric.SMALL_MAX}px)`, // 1279px

  MEDIUM: `screen and (min-width: ${ResponsiveMetric.MEDIUM_MIN}px) and (max-width: ${ResponsiveMetric.MEDIUM_MAX}px)`, //1280px ~ 1919px
  TIL_MEDIUM: `screen and (max-width: ${ResponsiveMetric.MEDIUM_MAX}px)`, // ~ 1919px

  LARGE: `screen and (min-width: ${ResponsiveMetric.LARGE_MIN}px)`, // 1920px ~
} as const;

export const MediaQuery = {
  EXTRA_SMALL: `@media ${MatchMedia.EXTRA_SMALL}`,

  SMALL: `@media ${MatchMedia.SMALL}`,
  TIL_SMALL: `@media ${MatchMedia.TIL_SMALL}`,

  MEDIUM: `@media ${MatchMedia.MEDIUM}`,
  TIL_MEDIUM: `@media ${MatchMedia.TIL_MEDIUM}`,

  LARGE: `@media ${MatchMedia.LARGE}`,
} as const;
